import { useSearchParams } from "react-router-dom";
import { MapStore } from "stores/MapStore";
import { alertErrorMessage } from "utils/alerts";
import useMap from "./useMap";
import { useEffect } from "react";


export default function useHandleParams(mapStore: MapStore) {

  const { fitMapToBoundsOfGeoJSON } = useMap(mapStore)
  const [searchParams] = useSearchParams();
  const building_id = searchParams.get("building_id");
  const level_id = searchParams.get("level_id");
  const user_lat = searchParams.get("user_lat");
  const user_long = searchParams.get("user_long");
  const beacon_id = searchParams.get("beacon_id");
  const venue_id = searchParams.get("venue_id");

  useEffect(() => {
    // check if user has valid URL params from click through from mobile app
    if (building_id !== null && level_id !== null && user_lat !== null && user_long !== null) {

      if (mapStore.loading)
        return

      const valid_building_id = mapStore.buildings.features.some(r => r.id === building_id)
      const level = mapStore.levels.features.find(r => r.id === level_id)
      const level_is_in_building = mapStore.getBuildingLevels(building_id).some(r => r.id === level_id)

      if (!valid_building_id || !level || !level_is_in_building) {
        alertErrorMessage('Parameters not supported for this venue');
        return
      }
      const ordinal = level.properties.ordinal
      mapStore.selectBuilding(building_id)
      mapStore.selectFloor(level.properties.ordinal)
      fitMapToBoundsOfGeoJSON(mapStore.getOrdinalLevels(building_id, ordinal))

    }
    // check if URL params are valid from click through from asset flyout
    if (beacon_id !== null && venue_id !== null && building_id !== null && level_id !== null) {

      if (mapStore.loading || mapStore.loadingAssets)
        return
      //check valid beacon_id
      const asset = mapStore.assets.find(r => r.assigned_beacon?.id === beacon_id)
      const level = mapStore.levels.features.find(r => r.id === level_id)
      if (!asset || !level) {
        alertErrorMessage('Could not locate Asset from Asset List');
        return
      }
      const ordinal = level.properties.ordinal
      mapStore.selectBuilding(building_id)
      mapStore.selectFloor(level.properties.ordinal)
      fitMapToBoundsOfGeoJSON(mapStore.getOrdinalLevels(building_id, ordinal))
      mapStore.selectBeacon(beacon_id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapStore.loading, mapStore.loadingAssets]) // only run when assets and users are done loading to ensure we have the data needed to validate the params

}